module.exports = __webpack_public_path__ + "img/round-exit_to_app-24px.c9151003.svg";